var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',{staticClass:"form-control",attrs:{"items":_vm.items,"hide-details":_vm.isHideDetails,"rules":_vm.rules,"label":"Evrak Türü","multiple":"","outlined":"","dense":""},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }